export const modifyRules = {
  name: [
    { required: true, message: '请输入平台名称', trigger: 'blur' }
  ],
  code: [
    { required: true, message: '请输入平台代码', trigger: 'blur' }
  ],
  url: [
    { required: true, message: '请输入平台地址', trigger: 'blur' }
  ]
}

export const addRules = {
  name: [
    { required: true, message: '请输入平台名称', trigger: 'blur' }
  ],
  code: [
    { required: true, message: '请输入平台代码', trigger: 'blur' }
  ],
  url: [
    { required: true, message: '请输入平台地址', trigger: 'blur' }
  ]
}
